// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueLazyload from 'vue-lazyload'

import zhLocale from 'view-design/src/locale/lang/zh-CN';//导入iview中文语言包
import enLocale from 'view-design/src/locale/lang/en-US';//导入iview英文语言包
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/images/none-img.png'),
  loading:require('@/assets/images/none-img.png'),
  attempt: 1,
})
Vue.use(VueLazyload)
import router from './router'
import VueI18n from 'vue-i18n' //引入国际化
import VueAwesomeSwiper from 'vue-awesome-swiper' //引入轮播
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )
import store from "./store/index";
import { getBrowserLang,getMenu } from "@/libs/util";
Vue.use(VueI18n)
Vue.use(ViewUI, {
  i18n: function(path, options) {
      let value = i18n.t(path, options);
      if (value !== null && value !== undefined) return value;

      return '';
  }
})
Vue.config.productionTip = false

const i18n = new VueI18n({
  locale: getBrowserLang() || 'en', // 定义默认语言为英文
  // locale: 'en', // 定义默认语言为英文
  messages: {
    'zh': Object.assign(zhLocale,require('@/assets/languages/zh.json')),
    'en': Object.assign(enLocale, require('@/assets/languages/en.json'))
    // 'zh': require('@/assets/languages/zh.json'),
    // 'en': require('@/assets/languages/en.json')
  }
})
import Viewer from 'v-viewer';

import 'viewerjs/dist/viewer.css';

Vue.use(Viewer)
Vue.locale = () => {}; // iview组件国际化不可缺少的部分
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {
    App
  },
  template: '<App/>'
})
// 注册点击除自身之外事件
Vue.directive('clickoutside', {
  bind(el, binding) {
    function handler(e) {
      if (el.contains(e.target)) {
        return false;
      }
      let isReturn = false
      // binding.arg.map(item => {
      //     if (document.querySelector('#' + item).contains(e.target)) {
      //         isReturn = true
      //     }
      // })
      if (isReturn) {
        return false
      }

      if (binding.expression) {
        binding.value(e);
      }
    }
    el._zClickOutside = handler;
    document.addEventListener('click', handler);
  },
  unbind(el) {
    // 解除事件监听
    document.removeEventListener('click', el._zClickOutside);
    delete el._zClickOutside;
  }
});
router.beforeEach((to, from, next) => {
  // console.log("先判断是否登录");
  
  // 从store中读取是否获取了已登录的信息
  var isLogin = store.state.user.login;
  
  if (!isLogin) {
    // 判断该路由是否需要登录权限
    if (to.meta.requireAuth || to.name == null) {
      // 把要跳转的地址作为参数传到下一步
      next({
        path: '/',
        query: {
          redirect: to.fullPath  // 使用 fullPath 包含查询参数
        }
      })
    } else {
      next();
    }
  } else {
    next();
  }
})

router.afterEach((to,form,next) => {
  document.querySelector('body').setAttribute('style','overflow: auto!important')
})

Vue.$httpRequestList = [] // 在 main.js文件中挂载




// WEBPACK FOOTER //
// ./src/main.js